import {
  FloatingGoToTopButton as FloatingGoToTopButtonBase,
  type GoToTopButtonProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function FloatingGoToTopButton(props: Omit<GoToTopButtonProps, "LinkComponent">) {
  return <FloatingGoToTopButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
